import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import animationEnd from '@mailobj-browser/front/js/events/types/animationEnd.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { remove } from '@mailobj-browser/front/js/tree/tree.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { modifiers } from '../../styles.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (element) => {
    const li = closest('li', element)

    removeMessage(li)
  }
})

const hideMessageBlock = (divMessage) => {
  const messages = all('li', divMessage)

  if (messages.length === 1) {
    // divMessage.classList.add(utilities.modifiers.display.none)
    // divMessage.classList.remove(utilities.modifiers.display.block)
    divMessage.style.display = 'none'
    divMessage.style.visibility = 'hidden'
  }
}

export const removeMessage = (li) => {
  if (Object.hasOwn(globalThis, 'onanimationend')) {
    li.classList.add(modifiers.snackbar.hide)
    onAnimationEnd.listen(li)
  } else {
    const divMessage = closest('#div_MESSAGE', li)
    remove(li)
    hideMessageBlock(divMessage)
  }
}

const onAnimationEnd = object(listener, {
  type: animationEnd,
  passive,
  task: (
    li
  ) => {
    const divMessage = closest('#div_MESSAGE', li)

    li.classList.add(modifiers.snackbar.hide)
    remove(li)

    hideMessageBlock(divMessage)
  }
})

export const closeByMessage = (ulMessage, items) => {
  for (const li of items) {
    remove(li)
  }

  const children = all('li', ulMessage)
  if (children.length === 1) {
    const divMessage = closest('#div_MESSAGE', ulMessage)
    hideMessageBlock(divMessage)
  }
}

export default element => {
  onClick.listen(element)
}
